// material-ui
import { useTheme } from '@mui/material/styles';
import { CircularProgress, Divider, Grid, Typography } from '@mui/material';

// project imports
import { gridSpacing } from 'store/constant';

// assets
import MainCard from 'ui/ui-component/cards/MainCard';
import ServicesCard from 'ui/ui-component/cards/ServicesCard';
import zimServices from './zim-services';
import { useState } from 'react';
import { useEffect } from 'react';
import handleAxiosError from 'utils/handleAxiosErrors';
import { useDispatch } from 'react-redux';
import { SNACKBAR_OPEN } from 'store/actions';
import PaynowBillerCard from 'ui/ui-component/cards/PaynowBillerCard';
import { axiosAuthenticated } from 'utils/axios';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import BillerDepartmentCard from 'ui/ui-component/cards/BillerDepartmentCard';
import { Helmet } from 'react-helmet-async';

// ==============================|| Zim Services Home Page ||============================== //

const ZimServicesHomePage = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [success, setFetchingDataSuccess] = useState(false);
    const [zimPaynowBillers, setZimPaynowBillers] = useState([]);
    const [fetchingError, setFetchingError] = useState('');

    useEffect(() => {
        const listBillers = async () => {
            try {
                setFetchingError('');
                setLoading(true);
                // const response = await axios.get(`${process.env.REACT_APP_PAYNOW_LIST_BILLERS_URL}`);

                const response = await axiosAuthenticated.post(
                    `${process.env.REACT_APP_BASE_URL}/method/simplex_billpay.simplex_billpay.api.list_billers`,
                    { group: true }
                );
                setZimPaynowBillers(response.data.message);
                setLoading(false);
                setFetchingDataSuccess(true);
            } catch (error) {
                setLoading(false);
                const errorMsg = handleAxiosError(error);
                setFetchingError(errorMsg);
                dispatch({
                    type: SNACKBAR_OPEN,
                    open: true,
                    message: errorMsg,
                    variant: 'alert',
                    alertSeverity: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }
                });
            }
        };
        listBillers();
    }, [dispatch]);

    let zimServicesResult = <></>;
    if (zimPaynowBillers) {
        zimServicesResult = zimPaynowBillers.map((billerData, key) => (
            <Grid key={key} item xs={12} lg={2} sm={6}>
                <BillerDepartmentCard department={billerData?.department} billers={billerData} />
            </Grid>
        ));
    }

    return (
        <>
            <Helmet>
                <title>Prepaid Services (ZIM) - Simplex Solutions</title>
                <link rel="canonical" href={`/services/zimbabwe/`} />
                <meta name="description" content="Prepaid Services (ZIM)" />
            </Helmet>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <MainCard
                        title={
                            <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                                <Grid item>
                                    <Typography variant="h3">Prepaid Services (ZIM)</Typography>
                                </Grid>
                            </Grid>
                        }
                    >
                        <Grid container spacing={gridSpacing}>
                            {loading && (
                                <Grid item xs={12}>
                                    <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
                                        <Grid item>
                                            <CircularProgress />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                            {zimServicesResult}
                        </Grid>
                    </MainCard>
                </Grid>
            </Grid>
        </>
    );
};

export default ZimServicesHomePage;
